import React, { useState } from "react";
import { TextField, Button, Container, Typography, Box } from "@mui/material";
import styled from "styled-components";
import MenuItem from "@mui/material/MenuItem";
import API from "../../../utils/api";

const FormContainer = styled(Container)`
  background-color: #1b1a2ea9;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0px 10px 10px 0px rgba(9, 5, 29, 0.171);
  backdrop-filter: blur(15px);
  color: white;
`;

const StyledTextField = styled(TextField)`
  & .MuiInputBase-root {
    color: white;
  }
  & .MuiInputLabel-root {
    color: white;
  }
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: white;
    }
    &:hover fieldset {
      border-color: #c770f0;
    }
    &.Mui-focused fieldset {
      border-color: #c770f0;
    }
  }
  margin-bottom: 1rem;
`;

const StyledButton = styled(Button)`
  background-color: #623686;
  color: white;
  &:hover {
    background-color: #6d20c5d7;
  }
`;
const difficulties = [
  {
    value: "Advanced",
    label: "Advanced",
  },
  {
    value: "Intermediate",
    label: "Intermediate",
  },
  {
    value: "Beginner",
    label: "Beginner",
  },
];
var format = {
  name: "",
  certificate: "",
  instructor: "",
  image: "",
  duration: "",
  courseLink: "",
  difficulty: "",
  completeDate: new Date().getDate(),
  description: "",
  completionPercentage: 100,
};
const CertificationForm = () => {
  const [certificationData, setCertificationData] = useState(format);

  const handleChange = (e) => {
    setCertificationData({
      ...certificationData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await API.post("/api/certification/add", certificationData);
      alert("Project submitted successfully");
      setCertificationData(format);
    } catch (error) {
      console.error(error);
      alert("Error submitting project", error);
    }
  };

  return (
    <Container fluid className="resume-section">
      <FormContainer maxWidth="sm">
        <Typography variant="h4" gutterBottom className="purple">
          Submit Your Certification
        </Typography>
        <form onSubmit={handleSubmit}>
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Name"
            name="name"
            value={certificationData.name}
            onChange={handleChange}
            required
          />
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Instructor"
            name="instructor"
            value={certificationData.instructor}
            onChange={handleChange}
            required
          />
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Image"
            name="image"
            value={certificationData.image}
            onChange={handleChange}
            required
          />
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Duration"
            name="duration"
            value={certificationData.duration}
            onChange={handleChange}
            type="number"
            required
          />
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Completion %"
            name="completionPercentage"
            value={certificationData.completionPercentage}
            onChange={handleChange}
            type="number"
            required
          />
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Course Link"
            name="courseLink"
            value={certificationData.courseLink}
            onChange={handleChange}
            required
          />
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Complete Date"
            name="completeDate"
            type="date"
            value={certificationData.completeDate}
            onChange={handleChange}
            required
          />
          <StyledTextField
            size="small"
            fullWidth
            select
            variant="outlined"
            label="Difficulty"
            name="difficulty"
            value={certificationData.difficulty}
            onChange={handleChange}
            required
          >
            {difficulties.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </StyledTextField>
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Certificate Link"
            name="certificate"
            value={certificationData.certificate}
            onChange={handleChange}
          />
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Description"
            name="description"
            multiline
            minRows={3}
            maxRows={10}
            value={certificationData.description}
            onChange={handleChange}
            type="text"
            required
          />
          <Box mt={2}>
            <StyledButton variant="contained" type="submit">
              Submit
            </StyledButton>
          </Box>
        </form>
      </FormContainer>
    </Container>
  );
};

export default CertificationForm;
